import type { Dispatch, SetStateAction } from "react";
import type { DiscardedFilter, ProvinceDTO } from "../../../api/contract";
import { Btn, Card } from "../../ui";
export type StatusFilter =
  | ""
  | "visura_ok"
  | "omonimi_found"
  | "no_match"
  | "error"
  | "too_many_results"
  | "pending"
  | "visura_pdf"
  | "captcha_pending"
  | "captcha_failed"
  | "tipo_visura_bounce";

interface ProspectFiltersProps {
  q: string; setQ: Dispatch<SetStateAction<string>>;
  provincia: string; setProvincia: Dispatch<SetStateAction<string>>;
  provOptions: Pick<ProvinceDTO, "code" | "name">[];
  soloCasaVuota: boolean; setSoloCasaVuota: Dispatch<SetStateAction<boolean>>;
  hideWorked: boolean; setHideWorked: Dispatch<SetStateAction<boolean>>;
  showFilters: boolean; setShowFilters: Dispatch<SetStateAction<boolean>>;
  status: StatusFilter; setStatus: Dispatch<SetStateAction<StatusFilter>>;
  discarded: DiscardedFilter; setDiscarded: Dispatch<SetStateAction<DiscardedFilter>>;
  minImmobili: number; setMinImmobili: Dispatch<SetStateAction<number>>;
  soloXml: boolean; setSoloXml: Dispatch<SetStateAction<boolean>>;
  workedCount: number;
}
export function ProspectFilters({ q, setQ, provincia, setProvincia, provOptions, soloCasaVuota, setSoloCasaVuota, hideWorked, setHideWorked, showFilters, setShowFilters, status, setStatus, discarded, setDiscarded, minImmobili, setMinImmobili, soloXml, setSoloXml, workedCount }: ProspectFiltersProps) {
  return (
      <Card
        title="Cerca e filtra"
        actions={<Btn size="sm" variant="ghost" onClick={() => setShowFilters((v) => !v)}>{showFilters ? "Meno filtri" : "Altri filtri"}</Btn>}
      >
        <div className="row gap-8" style={{ flexWrap: "wrap", alignItems: "flex-end" }}>
          <div className="field" style={{ flex: 1, minWidth: 240 }}>
            <label className="label" htmlFor="prospect-q">Cerca per nome o codice fiscale</label>
            <input
              id="prospect-q"
              className="input"
              placeholder="es. Rossi, RSSMRA30A01…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
          <div className="field" style={{ minWidth: 180 }}>
            <label className="label" htmlFor="prospect-prov">Provincia</label>
            <select id="prospect-prov" className="select" value={provincia} onChange={(e) => setProvincia(e.target.value)}>
              <option value="">Tutte</option>
              {provOptions.map((p) => (
                <option key={p.code} value={p.code}>
                  {p.name} ({p.code})
                </option>
              ))}
            </select>
          </div>
          <label className="check-chip" title="Indicazione dal necrologio da verificare: non identifica gli eredi né conferma che la casa sia vuota">
            <input type="checkbox" checked={soloCasaVuota} onChange={(e) => setSoloCasaVuota(e.target.checked)} />
            Solo coniuge non citato
          </label>
          <label className="check-chip" title="Nasconde le schede spuntate come già lavorate">
            <input type="checkbox" checked={hideWorked} onChange={(e) => setHideWorked(e.target.checked)} />
            Nascondi già lavorate{workedCount ? ` (${workedCount.toLocaleString("it-IT")})` : ""}
          </label>
        </div>
        {showFilters && (
          <div className="row gap-8" style={{ flexWrap: "wrap", alignItems: "flex-end", marginTop: 12 }}>
            <div className="field" style={{ minWidth: 200 }}>
              <label className="label" htmlFor="prospect-status">Esito della ricerca</label>
              <select id="prospect-status" className="select" value={status} onChange={(e) => setStatus(e.target.value as StatusFilter)}>
                <option value="">Tutti gli esiti</option>
                <option value="visura_ok">Visura letta</option>
                <option value="omonimi_found">Omonimi da scegliere</option>
                <option value="no_match">Nessuna corrispondenza</option>
                <option value="too_many_results">Troppi omonimi (oltre il limite SISTER)</option>
                <option value="visura_pdf">Dati da recuperare</option>
                <option value="captcha_pending">Codice di sicurezza in attesa</option>
                <option value="captcha_failed">Codice di sicurezza non letto</option>
                <option value="tipo_visura_bounce">Bloccata sul tipo di visura</option>
                <option value="error">Errore</option>
                <option value="pending">In coda</option>
              </select>
            </div>
            <div className="field" style={{ minWidth: 160 }}>
              <label className="label" htmlFor="prospect-discarded">Schede scartate</label>
              <select id="prospect-discarded" className="select" value={discarded} onChange={(e) => setDiscarded(e.target.value as DiscardedFilter)}>
                <option value="exclude">Nascondi</option>
                <option value="only">Solo scartate</option>
                <option value="include">Mostra anche</option>
              </select>
            </div>
            <div className="field" style={{ minWidth: 140 }}>
              <label className="label" htmlFor="prospect-min">Almeno N immobili</label>
              <input
                id="prospect-min"
                className="input"
                type="number"
                min={0}
                value={minImmobili}
                onChange={(e) => setMinImmobili(Math.max(0, Number(e.target.value) || 0))}
              />
            </div>
            <label className="check-chip" title="Solo le ricerche con la visura già scaricata">
              <input type="checkbox" checked={soloXml} onChange={(e) => setSoloXml(e.target.checked)} />
              Solo con visura scaricata
            </label>
          </div>
        )}
      </Card>
  );
}
